// removed by extract-text-webpack-plugin
module.exports = {"button":"_3Dn9C75IYibIJ1Qig38WWr"};